export default {
  methods: {
    viewSearchResults(filters) {
      this.$emit('applyFilters', filters)
      this.$refs.filter_popover.$emit('close')
    },

    changedFilterValue(filterList) {
      this.$emit('change', filterList)
    }
  }
}
